import { API_ROOT } from "../constants/constants";
import { getAccessToken } from "../utils/okta-config";

export async function getInfoDocument(name, providerId, opId, docType) {
  let result = [];
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/document/getDocuments/name/` +
      name +
      `/providerid/` +
      providerId +
      `/op/` +
      opId +
      `/docType/` +
      docType;
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
        "Content-Type": "application/pdf",
      },
    };
    const response = await fetch(url, requestOptions);

    if (response.status === 200) {
      result = await response.blob();
    }

    return result;
  } catch (error) {
    console.log(error);
  }
}
